// Vendors
import React from 'react';
// Components
import { ErrorComponent } from 'components/error/error.component';
// Constants
import { PROOF_INCOME_ERROR_COMPONENT_PROPS } from './constants/proof-income-error.constants';
// Hooks
import { useProofIncomeErrorHook } from './hooks/proof-income-error.hook';

const ProofIncomeErrorComponent = (): React.JSX.Element => {
  const { handleResetProofOfIncomeFlowButtonClick: onTryAgainClick } = useProofIncomeErrorHook();

  return <ErrorComponent {...{ ...PROOF_INCOME_ERROR_COMPONENT_PROPS, onTryAgainClick }} />;
};

export { ProofIncomeErrorComponent };
